import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Bank } from '../../models/banks';
import { TransfersOtherBanksService } from '../../transfers-other-banks/transfers-other-banks.service';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { CloseAccountService } from '../close-account.service';
import { Util } from '../../../utils/util';
import { Motivo } from '../models/motivos.model';

@Component({
	selector: 'app-close-account-request',
	templateUrl: './request.component.html',
	styleUrls: ['./request.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CloseAccountRequestComponent implements OnInit {

	public form: FormGroup;
	public reasons = [];
	public banks: Array<Bank> = [];
	public filteredBanks: Observable<Bank[]>;
	public destinationAccount: any;
	public destinationAccountOld: any;

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private transferOBService: TransfersOtherBanksService,
		private closeAccountService: CloseAccountService,
	) {}

	ngOnInit(): void {
		this.buildForm();
		this.getBanks();
		this.getReasons();
	}

	getReasons() {
		this.closeAccountService.getReasons().subscribe(data => {
			if (data.Sucesso && data.Existe) {
				this.reasons = Util.keysToCamel(data.Retorno);
			}
		});
	}

	getBanks() {
		this.transferOBService.getBanks().subscribe(data => {
			this.banks = data;
			this.filteredBanks = this.form.controls.bank.valueChanges.pipe(
				startWith({} as Bank),
				map(bank => bank && typeof bank === 'object' ? bank.label : bank),
				map(label => label ? this.filter(label) : this.banks.slice())
			);
		});
	}

	buildForm() {
		this.form = this.formBuilder.group({
			reason: [''],
			other: [''],
			bank: [''],
			agency: [''],
			number: [''],
		});
	}

	filter(val): Bank[] {
		return this.banks.filter(bank => bank.label.includes(val));
	}

	autoCompleteDisplay(bank: Bank): any {
		return bank ? bank.label : bank;
	}

	validateBank(e) {
		if (e.source !== undefined) {
			this.form.controls['bank'].setErrors(null);
		} else {
			this.form.controls['bank'].setErrors({ 'incorrect': true });
		}
	}

	destinationAccountMask(event) {
		if (event.keyCode === 8) {
		} else if (event.target.value.length <= 21) {
			let newVal = event.target.value.replace(/\D/g, '');
			if (newVal.length === 0) {
				newVal = '';
			} else {
				newVal = newVal.replace(/^(\d{0,19})*(\d{1})/, '$1-$2');
			}

			this.form.get('number').setValue(newVal);
			this.destinationAccountOld = newVal;

		} else {
			this.form.get('number').setValue(this.destinationAccountOld);
		}
	}

	submit() {
		if (this.form.valid) {
			let reason = [this.form.get('reason').value === 'other' ? this.form.get('other').value : this.form.get('reason').value];
			let bank = this.form.get('bank').value ? this.form.get('bank').value.label : '';

			this.closeAccountService.createRequest(
				bank,
				this.form.get('agency').value,
				this.form.get('number').value.replace('-', ''),
				reason
			);

			this.goToNextTab();
		}
	}

	changeReason(event: any) {
		if(event.value === 'other') {
			this.form.get('other').setValidators([Validators.required]);
		} else {
			this.form.get('other').setValidators(null);
		}

		this.form.get('other').updateValueAndValidity();
	}

	goBack = () => this.router.navigate(['minha-conta/encerramento/informacoes']);
	goToNextTab = () => this.router.navigate(['minha-conta/encerramento/termos']);

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/close-account/request/request.component.ts